import { FunctionComponent, useCallback } from 'react';
import { TableColProps } from '../../components/table';

import { ExamineeType } from '../../interfaces/ExamineeType';
import { ExamineeFamiliesService, ExamineeTypesService } from '../../services';
import { useAddError } from '../../context/error';
import { useNavigate } from 'react-router-dom';
import TableWithSearch, { OnDataParams, OnSearchParams } from '../../views/TableWithSearchView';
import { useAuth } from '../../context/auth';
import { get } from 'lodash';

const columns: TableColProps<ExamineeType>[] = [
  {
    title: 'Name',
    values: 'name',
    key: 'name',
    type: 'string',
    filterable: (addError, limit, page, query) =>
      (query && query.length > 0
        ? ExamineeTypesService(addError)
            .search(query)
            .then((res) => res.items)
        : ExamineeTypesService(addError)
            .list(limit, page)
            .then((res) => res.items)
      ).then((i) => i.map((v) => ({ value: v.name, title: v.name }))),
  },
  {
    title: 'Prüflingsgattung',
    values: 'family.name',
    key: 'family',
    type: 'number',
    filterable: (addError, limit, page, query) =>
      (query && query.length > 0
        ? ExamineeFamiliesService(addError)
            .search(query)
            .then((res) => res.items)
        : ExamineeFamiliesService(addError)
            .list(limit, page)
            .then((res) => res.items)
      ).then((i) => i.map((v) => ({ value: v.id, title: v.name }))),
  },
];

const List: FunctionComponent = () => {
  const navigate = useNavigate();
  const addError = useAddError();
  const auth = useAuth();

  const onNew = useCallback(() => {
    navigate('new');
  }, [navigate]);

  if (!auth || !auth.user) {
    return null;
  }

  return (
    <TableWithSearch
      title="Prüflingsarten"
      to="/settings"
      defaultLimit={get(auth, 'user.itemsPerPage', 25)}
      columns={columns}
      onData={function ({ filter, limit, page }: OnDataParams<ExamineeType>) {
        return ExamineeTypesService(addError).list<ExamineeType>(limit, page, filter);
      }}
      onSearch={function ({ limit, page, term }: OnSearchParams) {
        return ExamineeTypesService(addError).search<ExamineeType>(term, limit, page);
      }}
      onNew={onNew}
    />
  );
};

export default List;
